import * as actions from '../actions/applicationPolicy';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function postApplyPig(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.CREATE_APPLY_PIG)
        .map(action => ({
            url: BASE_URL + 'api/Pig',
            category: 'postApplyPig',
            method: 'POST',
            send: action.payload,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('postApplyPig')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveApplyPig(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function errorPostingApplyPig(sources) {
    let httpResponse$ = sources.HTTP
        .select('postApplyPig')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToApplyPig(response));

    return {
        ACTION: httpResponse$
    };
}
